import pagination from '@/helpers/pagination';

export default {
    ...pagination('billList').model,
};
